import * as React from 'react';
import banner from './assets/images/banner.jpg'
import bannerIcon from './assets/images/banner-logo-icon.png'
import icon1 from './assets/images/icon-1.png'
import icon2 from './assets/images/icon-2.png'
import icon3 from './assets/images/icon-3.png'
import { Button, Fade } from 'react-bootstrap';
import { CircularProgress, LinearProgress, Typography } from '@mui/material';
import { Footer } from './Footer';
import { Box } from '@mui/system';

export function Main() {
    const [open, setOpen] = React.useState(false);
    setTimeout(function () {
        setOpen(true)
    }.bind(this), 500)
    return (
        <Box>
            {open != true ? <LinearProgress color="inherit" /> :
                <Fade in={open} timeout={3000}>
                    <Box>
                        <div className="banner">
                            <div className="full-img" ><img src={banner} alt="" /></div>
                            <div className="container d-flex">
                                <div className="content">
                                    <Box display="flex" justifyContent="center"
                                        alignItems="center">
                                        <Box justifyContent="center"
                                            alignItems="center" sx={{ width: { xs: "20%", sm: "20%", md: "100%" } }}> <img src={bannerIcon} alt="" /></Box>

                                    </Box>


                                    <h1>The Qur’ān</h1>
                                    <h4>An Explanatory Translation</h4>
                                    {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elitsed do eiusmodest </p>
                                     <Button variant='contained' style={{color:"#FFF"}} >Read More</Button> */}

                                </div>
                            </div>
                        </div>

                        <div className="section home-w1">
                            <div className="container">
                                <div className="row">

                                    {/* About Us */}
                                    <div className="col-md-4">
                                        <img src={icon1} alt="About Icon" />
                                        <div className="pt-4 pb-4 coleql_height">
                                            <Typography variant="home_body_title">About</Typography><br />
                                            <Typography variant="default_body">
                                                This translation, with its embedded explanatory words, phrases, and notes, makes it easy for any reader to understand the message of God found in these verses, in their proper contexts. It also features headings and main topics, as well as a parallel English-Arabic translation, all designed to make studying and understanding the Qur’an more accessible for all.
                                                <br />
                                            </Typography>
                                        </div>
                                        <a target="_blank" href="https://al-m.ca/quran" className="btn" style={{ backgroundColor: '#dea90d', color: 'white' }}>Learn More</a>
                                        <br />
                                        <br />
                                    </div>

                                    {/* Find Quran */}
                                    <div className="col-md-4">
                                        <img src={icon2} alt="Find Quran Icon" />
                                        <div className="pt-4 pb-4 coleql_height">
                                            <Typography variant="home_body_title">Purchase a Copy</Typography><br />
                                            <Typography variant="default_body">
                                                If you prefer a hard copy of this translation, visit the link below to purchase your copy today.

                                            </Typography>
                                        </div>
                                        <a target="_blank" href="https://al-m.ca/bookstore/" className="btn" style={{ backgroundColor: '#dea90d', color: 'white' }}>Book Store</a>
                                        <br />
                                        <br />
                                    </div>

                                    {/* Download App */}
                                    <div className="col-md-4 text-center">
                                        <img src={icon3} alt="Download App Icon" />
                                        <div className="pt-4 pb-4 coleql_height">
                                            <Typography variant="home_body_title">Download the Qur’ān App</Typography><br />
                                            <Typography variant="default_body">
                                            Access The Qur’ān anytime, anywhere with our mobile app. Features include bookmarks, notes, screen modes, phrase and paragraph mode and more.
                                            </Typography>
                                        </div>

                                        <div className="d-flex justify-content-center gap-3 flex-wrap mt-3">
                                            {/* iOS Button */}
                                            <a
                                                href="https://apps.apple.com/app/6746337178"
                                                className="btn btn-dark d-flex align-items-center"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-apple fa-lg me-2"></i> iOS App
                                            </a>

                                            {/* Android Button */}
                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.almarif.quran.app"
                                                className="btn btn-success d-flex align-items-center"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fab fa-google-play fa-lg me-2"></i> Android App
                                            </a>
                                        </div>
                                       
                                    </div>

                                </div>
                            </div>
                        </div>



                        {/* <div className="section newsletter">
                            <div className="container">
                                <div className="content">
                                                <h4>Connect with us!</h4>
                                    <form action="#" method="post">
                                        <input type="text" className="form-control" placeholder="Enter your email" />
                                        <input type="submit" className="btn btn-primary" value="Subscribe" />
                                    </form>
                                                <ul className="social d-flex justify-content-center">
                                        <li><a href="#" target="_blank"><i className="fa-brands fa-facebook-f"></i></a></li>
                                        <li><a href="#" target="_blank"><i className="fa-brands fa-twitter"></i></a></li>
                                        <li><a href="#" target="_blank"><i className="fa-brands fa-instagram"></i></a></li>
                                        <li><a href="#" target="_blank"><i className="fa-brands fa-vimeo-v"></i></a></li>
                                        <li><a href="#" target="_blank"><i className="fa-brands fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}
                        <Footer />
                    </Box>

                </Fade>

            }


        </Box>

    )
}